export default __webpack_public_path__ + "static/media/icon-order-active.37656ff3.svg";